// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
const {sdk_conf={}} = window;
const prefix = sdk_conf.url_prefix;
console.log('sdk_cp', sdk_conf.ver);

export const ver = sdk_conf.ver;
export const config = sdk_conf;
export const url2md5 = url=>`${prefix}${url}?v=${sdk_conf.ver}`;
export default {ver, config, url2md5};
